import HttpClient from "./index";

class AuthApi extends HttpClient {
  constructor(token = null) {
    super(process.env.REACT_APP_APIBASE, token);
  }
  
  async adminLogin(data) {
    return await this.instance.post("/admin/login", data);
  };

  async forgotPassword(data) {
    return await this.instance.post("/admin/forgot-password", data);
  }

  async resetPassword(data) {
    return await this.instance.put("/admin/reset-password", data);
  }
}

export default AuthApi;
